"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.SectionDivider = exports.Section = exports.FormContainer = exports.Container = void 0;
const stitches_config_1 = require("../../../stitches.config");
const Layout_1 = require("../__styles__/Layout");
const Divider_1 = require("./Divider");
exports.Container = (0, stitches_config_1.styled)("div", {
    background: stitches_config_1.colors.bgUiSurface,
    envRelativeMinHeight: "100vh",
    display: "flex",
    transition: "margin-right 0.3s ease-in-out",
    "@media print": {
        alignItems: "normal !important",
        display: "block",
        width: "100%",
        minHeight: "100vh",
        pageBreakInside: "avoid",
        breakInside: "avoid",
    },
    form: {
        width: "100%",
        display: "flex",
        paddingBottom: "64px",
        flexDirection: "column",
    },
    variants: {
        hasHeaderNav: {
            true: {
                flexDirection: "column",
            },
        },
        centered: {
            true: {
                alignItems: "center",
                form: {
                    "@lg": {
                        width: "600px",
                    },
                },
            },
        },
        overflows: {
            true: {
                overflow: "auto",
            },
        },
        sidePanelOpen: {
            true: {
                marginRight: "524px",
            },
        },
    },
});
exports.FormContainer = (0, stitches_config_1.styled)("div", {
    display: "flex",
    padding: "0px 8px",
    "@lg": {
        padding: "0px",
    },
    "@media print": {
        justifyContent: "normal !important",
        minHeight: "auto",
        breakInside: "avoid",
    },
    variants: {
        centered: {
            true: {
                justifyContent: "center",
            },
        },
        width: {
            regular: {
                maxWidth: "600px",
            },
            wide: {
                maxWidth: "1000px",
            },
            auto: {
                width: "100%",
            },
        },
    },
});
exports.Section = (0, stitches_config_1.styled)(Layout_1.FlexColumn, {
    gap: "20px",
    variants: {
        grid: {
            true: {
                display: "grid",
                gridGap: "20px",
                gridTemplateColumns: "1fr 1fr",
            },
        },
    },
});
exports.SectionDivider = (0, stitches_config_1.styled)(Divider_1.Divider, {
    margin: "28px 0 0px 0px",
});
exports.Header = (0, stitches_config_1.styled)("div", {
    margin: "28px 0px",
});
//# sourceMappingURL=data:application/json;base64,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